import React, { useState, useEffect } from 'react';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Listen for sidebar state changes
  useEffect(() => {
    const handleSidebarToggle = (event) => {
      if (event.detail && event.detail.isCollapsed !== undefined) {
        setIsCollapsed(event.detail.isCollapsed);
      }
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle);
    return () => window.removeEventListener('sidebarToggle', handleSidebarToggle);
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-800">
      <Navigation />
      <div className={`flex-1 transition-all duration-300 bg-gray-800 ${isCollapsed ? 'md:ml-28' : 'md:ml-64'}`}>
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8 pt-20 md:pt-4 bg-gray-800">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout; 